<div class="container containerHome globalcontainer mainsection" *ngIf="!authenticationService.isLoading">
  <div>
    <br />
  </div>
</div>
<div *ngIf="!authenticationService.isLoading">
  <div>
    <br />
    <div class="divhome mainblock">
      <p>
        <i class="bi bi-house"></i>
        Welcome to the Vista REV-UP Webapp
      </p>
      <p class="maintitlehome">The webapp will give you access to three differents main sections.</p>
    </div>
    <br>
    <div class="divhome sectionblock">
      <div>
        <p class="mainsectiontitle">
          Main sections </p>

      </div>
    </div>
    <div class="divhome homecontainer">

      <br />





      <div class="card border-primary containerdata" (click)="ShowDataVisualization()"
        [ngClass]="this.permissionDataVisualisation == true  ? '' : 'disableSection'">
        <div class="card-body divcard">
          <div class="cardtitle">
            <div>
              <div class="circle">
                <i class="bi bi-bar-chart-line imageblock"></i>
              </div>
            </div>
            <div>
              <p class="card-title carttitledata">Data Visualization</p>
              <p class="card-text sizetextcardvis">
                This section grants you access to data retrieved by Vista from your systems. It allows you to check
                specific data on regular basis to detect any abnormal situation. It also allows you to access data if
                any question arise from dashboards end-users
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="card border-primary containerdata" (click)="ShowDataParameters()"
        [ngClass]="this.permissionDataParameters == true  ? '' : 'disableSection'">
        <div class="card-body divcard">
          <div class="cardtitle">
            <div>
              <div class="circle
  ">
                <i class="bi bi-sliders imageblock"></i>
              </div>
            </div>
            <div>
              <p class="card-title carttitledata">Data Input Parameters</p>
              <p class="card-text sizetextcardvis">
                This section enables the identified super-users to input and update key parameters. A date of
                application is mandatory. Any promotion event whose start date is after the application date will take
                the updated parameters into account.</p>
              <br />
            </div>
          </div>
        </div>
      </div>

      <div class="card border-primary containerdata" (click)="ShowSetting()"
        [ngClass]="this.permissionSettings == true  ? '' : 'disableSection'">
        <div class="card-body divcard">
          <div class="cardtitle">
            <div>
              <div class="circle">
                <i class="bi bi-gear imageblock"></i>
              </div>
            </div>
            <div>
              <p class="card-title carttitledata">Settings</p>
              <p class="card-text sizetextcardvis">
                This section enables super users to define and update individualized access rights. These access rights
                will define access to dashboards and access to web app.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>